<template>
  <a-popconfirm
    :title="alertTitle"
    ok-text="确定"
    cancel-text="取消"
    @confirm="$emit('onDelete')"
  >
    <a
      href="javascript:;"
      :class="disabledClass"
    >{{ text }}</a>
  </a-popconfirm>
</template>
<script>
export default {
  props: ['text', 'alertTitle', 'disabledClass'],
  data() {
    return {};
  },
};
</script>
